import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'

import DeleteAccountPopup from '@/app/components/billing/DeleteAccountPopup.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoDeleteAccount',
  setup(__props) {

const popupCancel = ref<InstanceType<typeof DeleteAccountPopup> | null>(null)

function showPopup(): void {
  if (!popupCancel.value) {
    return
  }

  popupCancel.value.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", null, "Delete Account", -1)),
    _cache[1] || (_cache[1] = _createElementVNode("p", null, " Your account and your data will be permanently deleted. You can downgrade to a free plan instead to keep it. ", -1)),
    _createElementVNode("button", {
      class: "delete-account__btn btns btns--red",
      onClick: showPopup
    }, " Delete your account "),
    _createVNode(DeleteAccountPopup, {
      ref_key: "popupCancel",
      ref: popupCancel
    }, null, 512)
  ]))
}
}

})